import React from "react";
import styles from "../../assets/scss/WebHomePagesscss/Priceing.module.scss";

const plans = [
  {
    title: "Try it free for 3 months — pay only if you love it.",

    // price: "3 Month Free",
    yearly: "",
    features: [
      "Onboard by invite - Farmer / Retail / Customer / Employee",
      "Mobile access for all",
      "No user limits",
      "Set permission for employees",
      "Easy invoice from farmers",
      "Automated inventory from invoices & out-of-stock option",
      "Market price adjustment option for every item",
      "Make payable bills to vendors & farmers",
      "Audit payments online on billing",
      "Automated ledger entry",
      "Audit payment on ledger",
      "Add header / footer / watermark of your choice in bills",
      "Logo on bills",
      "Thermal printer configuration",
      "Weighing scale integration",
      "Reports and insights",
      "Notification to retail owner and customer on outstanding bills",
      "GST Reports"
    ],

    buttonText: "Let’s talk",
    highlight: false,
  },
  // {
  //   title: "PRO",
  //   price: "₹350",
  //   yearly: "₹4199 yearly",
  //   features: [
  //     "Everything in PRO",
  //     "E-way Bills",
  //     "Multiple devices (Web, Android and iOS)",
  //     "User Activity",
  //     "Bulk Actions",
  //     "Inward/Return Delivery Challans",
  //   ],
  //   buttonText: "Choose Plan",
  //   highlight: true,
  // },
  // {
  //   title: "RISE",
  //   price: "₹417",
  //   yearly: "₹4999 yearly",
  //   features: [
  //     "Everything in JET",
  //     "Batch & Expiry",
  //     "Serial Number/IMEI Tracking",
  //     "Purchase Planning",
  //     "Manufacturing Inventory (BOM)",
  //     "POS Billing",
  //     "Online Store",
  //     "Sales Orders",
  //     "Party Grouping",
  //   ],
  //   buttonText: "Choose Plan",
  //   highlight: false,
  // },
  // {
  //   title: "BIZ",
  //   price: "Get in Touch",
  //   yearly: "",
  //   features: [
  //     "Everything in PRO",
  //     "Add Custom Features",
  //     "Multiple Businesses or Branches",
  //     "Online Stores",
  //     "Multiple Users",
  //     "Barcode Printing",
  //     "Multiple Languages / Multi Currency",
  //     "Chat Integration",
  //     "Custom Roles",
  //     "Data Storage",
  //     "Bulk Invoicing",
  //   ],
  //   buttonText: "Contact Us",
  //   highlight: false,
  // },
];

const Priceing = () => {
  return (
    <section className={styles.pricingSection}>
      <h2 className={styles.heading}>Freemium</h2>
      <p className={styles.heading}>
All features for everyone.      </p>
      <div className={styles.planContainer}>
        {plans.map((plan, i) => (
          <div
            key={i}
            className={`${styles.planCard} ${plan.highlight ? styles.highlight : ""
              }`}
          >
            {/* <h2 className={styles.heading}>Everything Included</h2> */}
            <h3 style={{ whiteSpace: "pre-line" }} className={styles.planTitle}>{plan.title}</h3>
            {/* <div className={styles.price}>{plan.price}<span>/month</span></div> */}
            {plan.yearly && <p className={styles.yearly}>{plan.yearly}</p>}
            <ul className={styles.features}>
              {plan.features.map((f, j) => (
                <li key={j}>{f}</li>
              ))}
            </ul>
            <button
              className={styles.button}
              onClick={() => {
                const contactSection = document.getElementById("contact");
                if (contactSection) {
                  const yOffset = -100; // <-- adjust this value
                  const y = contactSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
                  window.scrollTo({ top: y, behavior: "smooth" });
                }
              }}
            >
              {plan.buttonText}
            </button>

          </div>
        ))}
      </div>
    </section>
  );
};

export default Priceing;
